<template>
  <Button
    :icon="icon"
    :class="buttonClass"
    :style="{ color: buttonColor }"
    :disabled="disabled"
    v-tooltip.left="tooltipText"
    @click="handleClick"
  />
</template>

<script setup>
defineProps({
  icon: {
    type: String,
    required: true,
  },
  buttonClass: {
    type: String,
    default: "p-button-rounded p-button-outlined mr-2",
  },
  buttonColor: {
    type: String,
    default: "#000",
  },
  tooltipText: {
    type: String,
    default: "",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["click"]);

const handleClick = (event) => {
  emit("click", event);
};
</script>
